import * as React from "react";
import { forwardRef } from "react";
const SvgArrowToTop = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	id: "Vector",
	d: "M7 5.5V13M7 5.5L10 8.5M7 5.5L4 8.5M1 1H13",
	stroke: "currentColor",
	strokeWidth: 1.125,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgArrowToTop);
export default ForwardRef;
